import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {labels} from '../../../util/utils';

import StyledRelatedRiskIndicator from './StyledRelatedRiskIndicator';

const RelatedRiskIndicator = ({relatedRisk = null, className = null, isRiskAssertion = false, ...rest}) => {
	const props = {
		...rest,
		children: '',
		className: classNames({
			[`${className}`]: !!className,
			risk: isRiskAssertion,
			high: relatedRisk === 'H',
			empty: relatedRisk === null
		})
	};

	if (!isRiskAssertion && relatedRisk) {
		props.children = relatedRisk;
		if (relatedRisk === 'H') props.title = labels.higherInheritRisk;
		else props.title = labels.lowerInheritRisk;
	}
	if (isRiskAssertion) {
		if (relatedRisk === 'H') props.title = labels.riskAssociatedHigher;
		else props.title = labels.riskAssociated;
	}

	return <StyledRelatedRiskIndicator {...props} body2 />;
};

RelatedRiskIndicator.propTypes = {
	relatedRisk: PropTypes.oneOf(['H', 'L']),
	className: PropTypes.string,
	isRiskAssertion: PropTypes.bool
};

export default RelatedRiskIndicator;
